import {
  APIBlobResponse,
  PaginatedAPIResponse,
} from "../../../models/NetworkResponse";
import {
  GetStorageCostDetailParams,
  GetStorageCostParams,
  RecalculateStorageCostParams,
  StorageCostDetailItem,
  StorageCostListItem,
} from "../../../models/StorageCost/StorageCost";
import { downloadCSV, getAPI, postAPI } from "../../../api/Networking";
import { APIResponse } from "../../../models/NetworkResponse";
export default class StorageCostAPI {
  getStorageCostListing = async (
    params: GetStorageCostParams,
  ): Promise<PaginatedAPIResponse<StorageCostListItem>> => {
    try {
      const queryParams = new URLSearchParams();
      if (params.sort_by) queryParams.append("sort_by", params.sort_by);
      if (params.sort_type) queryParams.append("sort_type", params.sort_type);
      if (params.search_text)
        queryParams.append("search_text", params.search_text);
      if (params.customer_name)
        queryParams.append("customer_name", params.customer_name);
      if (params.partner_tag)
        queryParams.append("partner_tag", params.partner_tag);
      if (params.cost_date_from)
        queryParams.append("cost_date_from", params.cost_date_from);
      if (params.cost_date_to)
        queryParams.append("cost_date_to", params.cost_date_to);

      const response = await getAPI(
        `/v1/storagecost?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getStorageCostDetail = async (
    params: GetStorageCostDetailParams,
  ): Promise<PaginatedAPIResponse<StorageCostDetailItem>> => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("cost_date_from", params.cost_date_from);
      queryParams.append("cost_date_to", params.cost_date_to);
      if (params.sort_by) queryParams.append("sort_by", params.sort_by);
      if (params.sort_type) queryParams.append("sort_type", params.sort_type);
      if (params.partner_tag)
        queryParams.append("partner_tag", params.partner_tag);
      if (params.client_sku)
        queryParams.append("client_sku", params.client_sku);
      const response = await getAPI(
        `/v1/storagecost/${params.id}?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  recalculateStorageCost = async (
    params: RecalculateStorageCostParams,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v1/storagecost/recalculate`, {
        inventory_id: params.inventory_id,
        start_date: params.start_date,
        end_date: params.end_date,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  downloadStorageCostDetailReport = async (
    params: GetStorageCostDetailParams,
  ): Promise<APIBlobResponse> => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("cost_date_from", params.cost_date_from);
      queryParams.append("cost_date_to", params.cost_date_to);
      if (params.sort_by) queryParams.append("sort_by", params.sort_by);
      if (params.sort_type) queryParams.append("sort_type", params.sort_type);
      if (params.partner_tag)
        queryParams.append("partner_tag", params.partner_tag);
      if (params.client_sku)
        queryParams.append("client_sku", params.client_sku);
      queryParams.append("download_report", true.toString());
      const response = await downloadCSV(
        `/v1/storagecost/download-detail-report/${params.id}?${queryParams.toString()}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  searchTags = async (search_text: string): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v1/storagecost/search-tags?search_text=${search_text}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
